import type { ReactNode } from "react"

interface OrbitingIconProps {
  icon: ReactNode
  delay?: number
  initialAngle?: number // Added initialAngle prop
}

export function OrbitingIcon({ icon, delay = 0, initialAngle = 0 }: OrbitingIconProps) {
  return (
    <div
      className="absolute z-30"
      style={{
        animationDelay: `${delay}s`,
        transform: `rotate(${initialAngle}deg)`,
      }}
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center shadow-md animate-orbit will-change-transform"
        style={{ '--initial-angle': `${initialAngle}deg` } as React.CSSProperties} // Pass initialAngle as CSS variable
      >
        {icon}
      </div>
    </div>
  )
}